import { RaportHSPSpecsData } from './RaportHSPSpecs.types';

export const mockRaportHSPSpecsData: RaportHSPSpecsData = {
  engine: {
    engineType: 'Diesel, turbosprężarka z intercooler',
    engineDesignation: 'DETA (EA288 evo)',
    engineCapacity: '1968 cm³',
    power: '115 KM (85 kW) przy 3000-4200 obr/min',
    torque: '300 Nm przy 1500-2750 obr/min',
    fuelType: 'Diesel (ON)',
    cylindersCount: '4 (rzędowy)',
    valvesPerCylinder: '4 na cylinder (16 łącznie)',
    compressionRatio: '16,2:1',
    turbocharger: 'Turbosprężarka z chłodnicą powietrza doładowującego',
  },
  driveTrain: {
    driveType: 'Napęd na przód (FWD)',
    gearboxType: 'Manualna 6-biegowa',
    gearsCount: '6 + wsteczny',
    clutchType: 'Jednopłytkowe, suche',
    differentialType: 'Otwarty',
    transferCase: 'Brak (FWD)',
  },
  body: {
    bodyType: 'SUV/Crossover, 5-drzwiowy',
    doorsCount: '5 (w tym klapa bagażnika)',
    seatsCount: '5 (2+3)',
    trunkCapacity: '615 l (1655 l po złożeniu tylnych siedzeń)',
    fuelTankCapacity: '58 litrów',
    dragCoefficient: 'Cx = 0,31',
    paintType: 'Lakier metalizowany',
  },
  dimensions: {
    length: '4509 mm',
    width: '1839 mm (z lusterkami: 2099 mm)',
    height: '1658 mm',
    wheelbase: '2681 mm',
    frontTrack: '1584 mm',
    rearTrack: '1572 mm',
    groundClearance: '200 mm',
    curbWeight: '1620 kg',
    maxWeight: '2200 kg',
    towingCapacity: '2000 kg (z hamulcami), 750 kg (bez hamulców)',
  },
  wheelsSuspension: {
    frontWheelSize: '17" (7J x 17)',
    rearWheelSize: '17" (7J x 17)',
    frontTireSize: '215/65 R17',
    rearTireSize: '215/65 R17',
    frontSuspension: 'MacPherson ze sprężynami i amortyzatorami',
    rearSuspension: 'Wielowahaczowe z belką skrętną',
    frontBrakes: 'Wentylowane tarcze Ø312 mm',
    rearBrakes: 'Pełne tarcze Ø280 mm',
    steeringType: 'Elektryczne wspomaganie kierownicy (EPS)',
  },
  fuelEmission: {
    fuelConsumptionCity: '6,4 l/100km',
    fuelConsumptionHighway: '4,8 l/100km',
    fuelConsumptionCombined: '5,4 l/100km (WLTP)',
    co2Emission: '142 g/km (WLTP)',
    emissionStandard: 'Euro 6d',
    fuelTankCapacity: '58 litrów',
    range: '1074 km (przy zużyciu łącznym)',
  },
  other: {
    airConditioning: 'Dwustrefowa automatyczna klimatyzacja',
    heatingSystem: 'Ogrzewanie spalinowe z dodatkowymi grzejnikami',
    soundSystem: 'System audio 8 głośników',
    navigationSystem: 'Discover Media z ekranem 8"',
    keylessEntry: 'Kessy - dostęp i uruchamianie bezkluczykowe',
    startSystem: 'Start-Stop z rekuperacją energii',
    warranty: '2 lata bez ograniczenia przebiegu + 3 lata mobilności',
    serviceInterval: 'Co 15 000 km lub 12 miesięcy (WLongLife)',
  },
};

export const mockRaportHSPSpecsDataSimple: RaportHSPSpecsData = {
  engine: {
    engineType: '',
    engineDesignation: '',
    engineCapacity: '',
    power: '',
    torque: '',
    fuelType: '',
    cylindersCount: '',
    valvesPerCylinder: '',
    compressionRatio: '',
    turbocharger: '',
  },
  driveTrain: {
    driveType: '',
    gearboxType: '',
    gearsCount: '',
    clutchType: '',
    differentialType: '',
    transferCase: '',
  },
  body: {
    bodyType: '',
    doorsCount: '',
    seatsCount: '',
    trunkCapacity: '',
    fuelTankCapacity: '',
    dragCoefficient: '',
    paintType: '',
  },
  dimensions: {
    length: '',
    width: '',
    height: '',
    wheelbase: '',
    frontTrack: '',
    rearTrack: '',
    groundClearance: '',
    curbWeight: '',
    maxWeight: '',
    towingCapacity: '',
  },
  wheelsSuspension: {
    frontWheelSize: '',
    rearWheelSize: '',
    frontTireSize: '',
    rearTireSize: '',
    frontSuspension: '',
    rearSuspension: '',
    frontBrakes: '',
    rearBrakes: '',
    steeringType: '',
  },
  fuelEmission: {
    fuelConsumptionCity: '',
    fuelConsumptionHighway: '',
    fuelConsumptionCombined: '',
    co2Emission: '',
    emissionStandard: '',
    fuelTankCapacity: '',
    range: '',
  },
  other: {
    airConditioning: '',
    heatingSystem: '',
    soundSystem: '',
    navigationSystem: '',
    keylessEntry: '',
    startSystem: '',
    warranty: '',
    serviceInterval: '',
  },
};
